import { Mail, Users } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { cn } from "../lib/utils";
import { AudiencesPage } from "./comms/audiences";
import { TemplatesPage } from "./comms/templates";

const tabs = [
  { path: "/comms", label: "Email Templates", icon: Mail, end: true },
  { path: "/comms/audiences", label: "Target Audiences", icon: Users, end: false },
];

export function CommsPage(): React.ReactElement {
  const location = useLocation();
  const isAudiences = location.pathname === "/comms/audiences";

  return (
    <div className="space-y-3">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Bulk Communications</h1>
        <p className="text-sm text-muted-foreground">Manage email templates and target audiences</p>
      </div>
      <div className="flex gap-1 border-b">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors",
                isActive
                  ? "border-primary text-primary"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )
            }
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}
          </NavLink>
        ))}
      </div>
      <div className="pt-2">{isAudiences ? <AudiencesPage /> : <TemplatesPage />}</div>
    </div>
  );
}
